/*
 * @Descripttion: 文本json文件
 * @version:
 * @Author: leo.liu
 * @Date: 2021-08-29 06:52:13
 * @LastEditors: qianlishi
 * @LastEditTime: 2021-09-28 14:20:12
 */
export const widgetCard = {
  code: "widget-card",
  type: "html",
  label: "数字卡片",
  icon: "icon-shuzikapian",
  options: {
    // 配置
    setup: [
      // {
      //   type: "el-input-text",
      //   label: "图层名称",
      //   name: "layerName",
      //   required: false,
      //   placeholder: "",
      //   value: "文本框",
      // },
      {
        type: "el-input-text",
        label: "标题名称",
        name: "text",
        required: false,
        value: "数字卡片",
      },
      {
        type: "vue-color",
        label: "标题颜色",
        name: "titleColor",
        required: false,
        placeholder: "",
        dark: '#BFBFBF',
        value: "#677392",
      },
      {
        type: "el-input-number",
        label: "标题大小",
        name: "titleSize",
        required: false,
        placeholder: "",
        value: "12",
      },
      {
        type: "vue-color",
        label: "指标颜色",
        name: "normColor",
        required: false,
        placeholder: "",
        dark: '#FFFFFF',
        value: "#2D3446",
      },
      {
        type: "el-input-number",
        label: "指标大小",
        name: "normSize",
        required: false,
        placeholder: "",
        value: "24",
      },
      {
        type: "vue-color",
        label: "对比颜色",
        name: "compareColor",
        required: false,
        placeholder: "",
        value: "#677392",
      },
      {
        type: "el-input-number",
        label: "对比大小",
        name: "compareSize",
        required: false,
        placeholder: "",
        dark: '#BFBFBF',
        value: "12",
      },
      {
        type: "vue-color",
        label: "背景颜色",
        name: "background",
        required: false,
        placeholder: "",
        dark: '#262626',
        value: "#FFFFFF",
      },
      // {
      //   type: "el-input-number",
      //   label: "字体大小",
      //   name: "fontSize",
      //   required: false,
      //   placeholder: "",
      //   value: "26",
      // },
      // {
      //   type: "vue-color",
      //   label: "字体颜色",
      //   name: "color",
      //   required: false,
      //   placeholder: "",
      //   value: "#FAD400",
      // },
      // {
      //   type: "vue-color",
      //   label: "字体背景",
      //   name: "background",
      //   required: false,
      //   placeholder: "",
      //   value: "rgba(115,170,229,.0)",
      // },
      // {
      //   type: "el-select",
      //   label: "文字粗细",
      //   name: "fontWeight",
      //   required: false,
      //   placeholder: "",
      //   selectOptions: [
      //     { code: "normal", name: "正常" },
      //     { code: "bold", name: "粗体" },
      //     { code: "bolder", name: "特粗体" },
      //     { code: "lighter", name: "细体" },
      //   ],
      //   value: "normal",
      // },
      // {
      //   type: "el-select",
      //   label: "对齐方式",
      //   name: "textAlign",
      //   required: false,
      //   placeholder: "",
      //   selectOptions: [
      //     { code: "center", name: "居中" },
      //     { code: "left", name: "左对齐" },
      //     { code: "right", name: "右对齐" },
      //   ],
      //   value: "center",
      // },
    ],
    // 数据
    data: [
      {
        type: "el-radio-group",
        label: "数据类型",
        name: "dataType",
        require: false,
        placeholder: "",
        selectValue: true,
        selectOptions: [
          {
            code: "staticData",
            name: "静态数据",
          },
          {
            code: "dynamicData",
            name: "动态数据",
          },
        ],
        value: "dynamicData",
      },
      {
        type: "el-button",
        label: "静态数据",
        name: "staticData",
        required: false,
        placeholder: "",
        relactiveDom: "dataType",
        relactiveDomValue: "staticData",
        value: "数字卡片",
      },
      {
        type: "dycustComponents",
        label: "动态数据",
        name: "dynamicData",
        required: false,
        placeholder: "",
        relactiveDom: "dataType",
        chartType: "widget-card",
        dictKey: "CARD_PROPERTIES",
        relactiveDomValue: "dynamicData",
        value: {},
      },
    ],

    // 坐标
    position: [
      {
        type: "el-input-number",
        label: "左边距",
        name: "left",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "上边距",
        name: "top",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "宽度",
        name: "width",
        required: false,
        placeholder: "该容器在1920px大屏中的宽度",
        value: 240,
      },
      {
        type: "el-input-number",
        label: "高度",
        name: "height",
        required: false,
        placeholder: "该容器在1080px大屏中的高度",
        value: 104,
      },
    ],
  },
};
